export default "__VITE_ASSET__BoUTGU38__"